import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    announceA11y: (message: string) => void;
  }
}

export function LiveRegion() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.announceA11y = (message: string) => {
      if (!ref.current) return;
      // Clear then set to ensure screen readers re-announce even repeated messages
      ref.current.textContent = '';
      requestAnimationFrame(() => {
        if (ref.current) ref.current.textContent = message;
      });
    };
    return () => {
      window.announceA11y = () => {};
    };
  }, []);

  return (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    />
  );
}
